import { Shape } from "@kosmod/pancake"
import { AnyLogicState, LogicKey } from "./all";

export function define<const K extends string, const S extends Shape.Any>(key: K, state: S) {
  return {
    key,
    state,
  };
}
